import './App.css';

function App() {
  return (
    <div className="App">
      <img src="BiDo.jpeg" alt="BiDo Logo" className='logo'></img>
    </div>
  );
}

export default App;
